import { doc } from "./util.js";

let stack = null;
const ICONS = { success: "✓", error: "!", info: "i" };

function getStack() {
  if (stack && doc.body.contains(stack)) return stack;
  stack = doc.getElementById("toastStack");
  if (!stack) {
    stack = doc.createElement("div");
    stack.id = "toastStack";
    stack.className = "toast-stack";
    stack.setAttribute("role", "region");
    stack.setAttribute("aria-live", "polite");
    stack.setAttribute("aria-label", "Notifications");
    doc.body.appendChild(stack);
  }
  return stack;
}

export function mrToast(message, type = "success") {
  const el = doc.createElement("div");
  el.className = "toast toast--" + type;
  el.setAttribute("role", type === "error" ? "alert" : "status");

  const icon = doc.createElement("span");
  icon.className = "toast__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.textContent = ICONS[type] || ICONS.info;

  const msg = doc.createElement("span");
  msg.className = "toast__msg";
  msg.textContent = message;

  const close = doc.createElement("button");
  close.type = "button";
  close.className = "toast__close";
  close.setAttribute("aria-label", "Dismiss");
  close.textContent = "×";

  el.append(icon, msg, close);
  getStack().appendChild(el);
  requestAnimationFrame(() => el.classList.add("is-in"));

  let timer = 0;
  const remove = () => {
    clearTimeout(timer);
    el.classList.remove("is-in");
    el.classList.add("is-out");
    setTimeout(() => el.remove(), 300);
  };
  close.addEventListener("click", remove);
  timer = setTimeout(remove, 5500);
  return el;
}

export function initToast() {
  window.mrToast = mrToast;
}
